"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Configuration = void 0;
class Configuration {
  constructor(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let config = options.notifications || {};
    const region = config.region || options.region || 'us1';
    const defaultUrl = "https://ers.".concat(region, ".twilio.com/v1/registrations");
    this.registrarUrl = config.ersUrl || defaultUrl;
    this._token = token;
  }
  updateToken(token) {
    this._token = token;
  }
  get token() {
    return this._token;
  }
}
exports.Configuration = Configuration;